module.exports = __webpack_public_path__ + "static/cursor-c381d12ed7ddb62c196d1dbdc28f020b.svg";